import React from 'react';
import { SectionProjects } from '../components/SectionProjects/SectionProjects';

export const Projects = () => {
  return(
    <>
      <SectionProjects />
    </>
  );
};